import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar-d-menu',
  templateUrl: './navbar-d-menu.component.html',
  styleUrls: ['./navbar-d-menu.component.scss']
})
export class NavbarDMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
